import React from "react"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Flow from "./Flow"
import FlowPSE from "./Execution/FlowPSE"

export default function FlowPage() {
    const [page, setPage] = React.useState("pse")

    const handleChange = (event, newPage) => {
        setPage(newPage)
    }

    return (
        <div className="flexColumn stretch flex1">
            <div className="centerSelf">
                <Tabs value={page} onChange={handleChange}>
                    <Tab label="Recette" value="recipe"/>
                    <Tab label="Etapes de production" value="pse"/>
                </Tabs>
            </div>
            <div style={{height: 16}}/>
            {page === "recipe" && <Flow recipeId="nv29GdOTZd"/>}
            {page === "pse" && <FlowPSE dayTimestamp={1763769600000}/>}
        </div>
    )
}

export const SECTION_COLOR = "#2196F3"
export const SECTION_TEXT_COLOR = "#FFFFFF"
export const STEP_COLOR = "#E3F2FD"
export const STEP_TEXT_COLOR = "#000000"
export const STEP_TEXT_OTHER_DAY_COLOR = "#888888"
export const BOLD_STYLE = {fontWeight: 600}